import { faEdit } from "@fortawesome/free-solid-svg-icons";
import UnForm from "../../../Form";
import { GetCidadeController } from "../../../../Controllers/Geral/Endereco/Cidade/CidadeControllers";
import { ListarEstadosController } from "../../../../Controllers/Geral/Endereco/Estado/EstadoControllers";
import { BuscaCEP } from "../../../../Services/Tools/ViaCep";
import { ValidationErr } from "../../../../Validations/ValidationError";
import { FormProvider, useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { ICidade } from "../../../../Interfaces/Geral/Endereco/Cidade/CidadeInterfaces";
import { cpfOrCnpjValidator } from "../../../../Validations/InputValidation";
import { FormatterCPF } from "../../../../Validations/InputMasks";
import { AtualizarContatoController } from "../../../../Controllers/Geral/Contatos/ContatosController";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { IContatos } from "../../../../Interfaces/Geral/Contatos/ContatosInterfaces";
import { ListarTipoRelacaoClienteController } from "../../../../Controllers/Geral/GestaoDeCadastros/TipoRelacaoCliente/TipoRelacaoClienteControllers";

interface ICadastrarContatoProps {
    setShow: (show: boolean) => void;
    update: () => void;
    idContato: number;
    row: IContatos;
}

export default function EditarContato(props: ICadastrarContatoProps) {
    function handleCadastrarContatoFormSubmit(formData: IContatos) {
        atualizarContato(
            {
                ...formData,
                ID_CONTATO: props.idContato,
                NR_CEP: formData.NR_CEP?.replace(/([^\d])+/gim, ""),
                DS_BAIRRO: bairro,
                DS_CIDADE: cidade?.DS_CIDADE,
                DS_ESTADO: ufEstado,
                ID_CONTA_CONTATO: props.row.ID_CONTA_CONTATO,
            },
            formData.ID_TIPO_RELACAO_CLIENTE ?? 0,
            true
        ).then(() => {
            props.setShow(false);
            props.update();
        });
    }

    const { execute: atualizarContato, loading } = useAsyncCallback(
        AtualizarContatoController
    );
    const [bairro, setBairro] = useState<string>();
    const [ufEstado, setUfEstado] = useState<string>();

    const [cidade, setCidade] = useState<ICidade>();
    const [estadoID, setEstadoID] = useState<number>();

    const FormMethods = useForm();
    const { getValues, setValue, register } = FormMethods;

    useEffect(() => {
        if (props.row.NR_CEP) {
            BuscaCEP(Number(props.row.NR_CEP?.replace(/([^\d])+/gim, "")))
                .then((InformCep) => {
                    GetCidadeController(InformCep.localidade).then((cidade) => {
                        setCidade(cidade);
                        setEstadoID(cidade.ID_ESTADO);
                    });
                    setValue(`DS_BAIRRO`, InformCep.bairro);
                    setValue(`DS_LOGRADOURO`, InformCep.logradouro);
                    setBairro(InformCep.bairro);
                    setUfEstado(InformCep.uf);
                })
                .catch(ValidationErr);
        }
    }, [props.row.NR_CEP, setValue]);

    return (
        <FormProvider {...FormMethods}>
            <UnForm
                className="w-100 align-itens-center mt-5 row m-0"
                handleSubmit={handleCadastrarContatoFormSubmit}
                usingContext
            >
                <div className="form-group row">
                    <div className="col-12 col-lg-12 mt-2">
                        <UnForm.Input
                            wrapperClassName="w-100"
                            label="Informe o Nome: *"
                            name="DS_NOME"
                            defaultValue={props.row.DS_NOME}
                            className={`form-control px-0 p-2 placeholder-muted-75`}
                            registerOptions={{
                                required: "Insira o Nome",
                            }}
                        />
                    </div>

                    <div className="col-12 col-lg-6 mt-2">
                        <UnForm.Input
                            label="Email:"
                            type="text"
                            name="DS_EMAIL"
                            defaultValue={props.row.DS_EMAIL}
                            className={`form-control px-0 p-2 placeholder-muted-75`}
                        />
                    </div>
                    <div className="col-12 col-lg-6 mt-2">
                        <UnForm.Input
                            label="CPF/CNPJ:"
                            name="NR_CPF"
                            defaultValue={props.row.NR_CPF}
                            onChange={(event) =>
                                FormatterCPF(event.target.value)
                            }
                            className={`form-control px-0 p-2 placeholder-muted-75`}
                            registerOptions={{
                                validate: (cpf) => {
                                    return (
                                        (cpf
                                            ? cpfOrCnpjValidator(cpf)
                                            : true) || "CPF ou CNPJ inválido!"
                                    );
                                },
                            }}
                        />
                    </div>

                    <div className="col-12 col-lg-6 mt-2">
                        <UnForm.Input
                            label="CEP:"
                            wrapperClassName="w-100"
                            defaultValue={props.row.NR_CEP}
                            type="text"
                            name={`NR_CEP`}
                            className="form-control"
                            onChange={(e) => {
                                // Adicionado formatador de CEP
                                const unformattedCep = e.target.value.replace(
                                    /([^\d])+/gim,
                                    ""
                                );
                                let formattedCep = "";

                                if (unformattedCep.length >= 5) {
                                    formattedCep = `${unformattedCep.slice(
                                        0,
                                        2
                                    )}.${unformattedCep.slice(2, 5)}`;
                                }

                                if (unformattedCep.length > 5) {
                                    formattedCep += `-${unformattedCep.slice(
                                        5,
                                        8
                                    )}`;
                                }

                                setValue(
                                    `NR_CEP`,
                                    formattedCep || e.target.value
                                );
                            }}
                        />
                        <div className="input-icon input-icon-right">
                            <span
                                className="input-icon input-icon-right cursor-pointer"
                                onClick={async () => {
                                    const cep =
                                        `${getValues(`NR_CEP`)}`?.replace(
                                            /([^\d])+/gim,
                                            ""
                                        ) || "0";
                                    if (cep?.length === 8) {
                                        await BuscaCEP(Number(cep))
                                            .then((InformCep) => {
                                                GetCidadeController(
                                                    InformCep.localidade
                                                ).then((cidade) => {
                                                    setCidade(cidade);
                                                    setEstadoID(
                                                        cidade.ID_ESTADO
                                                    );
                                                });
                                                setValue(
                                                    `DS_BAIRRO`,
                                                    InformCep.bairro
                                                );
                                                setBairro(InformCep.bairro);
                                                setValue(
                                                    `DS_LOGRADOURO`,
                                                    InformCep.logradouro
                                                );
                                                setUfEstado(InformCep.uf);
                                            })
                                            .catch(ValidationErr);
                                    }
                                }}
                            >
                                <i className="flaticon2-search-1 icon-md mb-12"></i>
                            </span>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6 mt-2">
                        <UnForm.LazySelect
                            label="Estado:"
                            name="DS_ESTADO"
                            // defaultValue={props.row.DS_ESTADO}
                            controller={ListarEstadosController}
                            getDS={(e) => e.DS_ESTADO}
                            getKeyValue={(e) => e.ID_ESTADO}
                            disabled
                            className={`form-control px-0 p-2 placeholder-muted-75`}
                            value={estadoID}
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    </div>
                    <div className="col-12 col-lg-6 mt-2">
                        <UnForm.Select
                            label="Cidade:"
                            name="ID_CIDADE"
                            disabled
                            defaultValue={props.row.ID_CIDADE}
                            className={`form-control px-0 p-2 placeholder-muted-75`}
                            value={cidade?.ID_CIDADE}
                        >
                            <option
                                defaultValue={props.row.ID_CIDADE}
                                value={cidade?.ID_CIDADE}
                            >
                                {cidade?.DS_CIDADE}
                            </option>
                        </UnForm.Select>
                    </div>
                    <div className="col-12 col-lg-6 mt-2">
                        <UnForm.Input
                            label="Bairro:"
                            type="text"
                            name="DS_BAIRRO"
                            defaultValue={props.row.DS_BAIRRO}
                            className={`form-control px-0 p-2 placeholder-muted-75`}
                            {...register("DS_BAIRRO")}
                            value={getValues("DS_BAIRRO")}
                        />
                    </div>
                    <div className="col-12 col-lg-12 mt-2">
                        <UnForm.Input
                            label="Endereço:"
                            type="text"
                            name="DS_LOGRADOURO"
                            defaultValue={props.row.DS_LOGRADOURO}
                            value={getValues("DS_LOGRADOURO")}
                            className={`form-control px-0 p-2 placeholder-muted-75`}
                            {...register("DS_LOGRADOURO")}
                        />
                    </div>
                    <div className="col-12 col-lg-6 mt-2">
                        <UnForm.Input
                            label="Número:"
                            defaultValue={props.row.NR_ENDERECO}
                            type="text"
                            name="NR_ENDERECO"
                            className={`form-control px-0 p-2 placeholder-muted-75`}
                        />
                    </div>
                    <div className="col-12 col-lg-6 mt-2">
                        <UnForm.Input
                            label="Complemento:"
                            defaultValue={props.row.DS_COMPLEMENTO_ENDERECO}
                            type="text"
                            name="DS_COMPLEMENTO_ENDERECO"
                            className={`form-control px-0 p-2 placeholder-muted-75`}
                        />
                    </div>
                    <div className="col-12 col-lg-12 mt-2">
                        <label>Tipo de Relação com Cliente:</label>
                        <UnForm.LazySelect
                            controller={ListarTipoRelacaoClienteController}
                            getDS={(trc) => trc.DS_TIPO_RELACAO_CLIENTE}
                            getKeyValue={(trc) => trc.TIPO_RELACAO_CLIENTE}
                            defaultValue={props.row.ID_TIPO_RELACAO_CLIENTE}
                            name="ID_TIPO_RELACAO_CLIENTE"
                            placeholder={"Digite o número do telefone:"}
                            className={`form-control px-0 p-2 placeholder-muted-75`}
                            registerOptions={{
                                required: "Insira o Tipo Relação Cliente",
                            }}
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    </div>
                </div>

                <UnForm.SubmitButton
                    color="success"
                    icon={faEdit}
                    className="col-12 mt-5"
                    loading={loading}
                >
                    Editar Contato
                </UnForm.SubmitButton>
            </UnForm>
        </FormProvider>
    );
}
